/*
  bt-lokalisierung.js · Verhalten des Land-/Sprachwaehlers (snippets/bt-lokalisierung)
  Angelegt 30.09.2026 (Mehrsprachigkeit). Seit 14.10.2026 gibt es das Panel nur
  noch fuer "Lieferland aendern" im Footer; die Sprachleiste (.bt-loc__bar) sind
  einfache Submit-Buttons und braucht hier nur den Busy-Zustand beim Absenden.

  - Footer: Panel schwebt (position:fixed) am Knopf, weil die Top-Bar
    overflow:hidden hat und beim Scrollen einklappt. Unter 600px Breite wird es
    ein Bottom-Sheet mit Abdunklung.
  - Drawer: Panel klappt im Menue auf (kein Schweben).
  - Escape schliesst und gibt den Fokus an den Knopf zurueck, Klick ausserhalb
    schliesst, Pfeiltasten wandern durch die Optionen.
  - Beim Oeffnen bekommt die aktuell gewaehlte Option den Fokus.
*/
(function () {
  'use strict';

  var MOBILE = 600;
  var openRoot = null;
  var scrim = null;

  function toggleOf(root) { return root.querySelector('[data-bt-loc-toggle]'); }
  function floating(root) { return root.getAttribute('data-variante') !== 'drawer'; }

  function ensureScrim() {
    if (scrim) return scrim;
    scrim = document.createElement('div');
    scrim.className = 'bt-loc__scrim';
    scrim.hidden = true;
    scrim.addEventListener('click', function () { close(openRoot, false); });
    document.body.appendChild(scrim);
    return scrim;
  }

  function place(root) {
    var panel = panelOf(root);
    var btn = toggleOf(root);
    if (!floating(root)) return;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    if (vw < MOBILE) {
      panel.classList.add('is-sheet');
      panel.style.left = panel.style.top = panel.style.maxHeight = '';
      ensureScrim().hidden = false;
      return;
    }
    panel.classList.remove('is-sheet');
    if (scrim) scrim.hidden = true;
    var r = btn.getBoundingClientRect();
    panel.style.maxHeight = '';
    var w = panel.offsetWidth;
    var h = panel.offsetHeight;
    var left = Math.min(Math.max(8, r.right - w), vw - w - 8);
    var below = vh - r.bottom - 14;
    var above = r.top - 14;
    var top;
    if (h <= below || below >= above) {
      top = r.bottom + 6;
      panel.style.maxHeight = Math.max(160, below) + 'px';
    } else {
      var mh = Math.max(160, above);
      top = Math.max(8, r.top - 6 - Math.min(h, mh));
      panel.style.maxHeight = mh + 'px';
    }
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
  }

  function options(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.bt-loc__opt'));
  }

  function open(root) {
    if (openRoot && openRoot !== root) close(openRoot, false);
    var panel = panelOf(root);
    panel.hidden = false;
    root.classList.add('is-open');
    toggleOf(root).setAttribute('aria-expanded', 'true');
    openRoot = root;
    place(root);
    var cur = root.querySelector('.bt-loc__opt[aria-current="true"]') || options(root)[0];
    if (cur && floating(root)) {
      try { cur.focus({ preventScroll: true }); } catch (e) { cur.focus(); }
      if (cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
    }
  }

  function close(root, refocus) {
    if (!root) return;
    var panel = panelOf(root);
    panel.hidden = true;
    root.classList.remove('is-open');
    toggleOf(root).setAttribute('aria-expanded', 'false');
    if (scrim) scrim.hidden = true;
    if (openRoot === root) openRoot = null;
    if (refocus) toggleOf(root).focus();
  }

  function init(root) {
    if (root.__btLoc) return;
    root.__btLoc = true;
    var panel = panelOf(root);
    if (floating(root) && panel.parentNode !== document.body) {
      // Aus dem Header/Footer herausnehmen: sonst schneidet overflow:hidden der Top-Bar ab
      // und position:fixed haengt am transformierten Sticky-Header statt am Viewport.
      panel.__btLocRoot = root;
      document.body.appendChild(panel);
      root.__btLocPanel = panel;
    }
    toggleOf(root).addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (root.classList.contains('is-open')) close(root, false); else open(root);
    });
    var closeBtn = panel.querySelector('[data-bt-loc-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { close(root, true); });
    panel.addEventListener('keydown', function (e) {
      var opts = Array.prototype.slice.call(panel.querySelectorAll('.bt-loc__opt'));
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!opts.length) return;
        var n = i < 0 ? 0 : (i + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts[n].focus();
      } else if (e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        if (opts.length) opts[e.key === 'Home' ? 0 : opts.length - 1].focus();
      } else if (e.key === 'Escape') {
        e.stopPropagation();
        close(root, true);
      } else if (e.key === 'Tab' && floating(root)) {
        // Fokus im schwebenden Panel halten
        var f = Array.prototype.slice.call(panel.querySelectorAll('button:not([disabled])'));
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    panel.addEventListener('submit', function () {
      panel.classList.add('is-busy');
      panel.setAttribute('aria-busy', 'true');
    });
  }

  function panelOf(root) { return root.__btLocPanel || root.querySelector('.bt-loc__panel'); }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bt-loc]'), init);
  }

  document.addEventListener('click', function (e) {
    if (!openRoot) return;
    var panel = panelOf(openRoot);
    if (panel.contains(e.target) || toggleOf(openRoot).contains(e.target)) return;
    close(openRoot, false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openRoot) close(openRoot, true);
  });
  document.addEventListener('submit', function (e) {
    var bar = e.target;
    if (!bar.classList || !bar.classList.contains('bt-loc__bar')) return;
    bar.classList.add('is-busy');
    bar.setAttribute('aria-busy', 'true');
  });
  window.addEventListener('resize', function () { if (openRoot) place(openRoot); });
  window.addEventListener('scroll', function () {
    if (openRoot && floating(openRoot) && window.innerWidth >= MOBILE) place(openRoot);
  }, { passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  // Theme-Editor: Sections werden neu geladen
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-bt-loc]'), function (root) {
      if (openRoot === root) close(root, false);
      if (root.__btLocPanel && root.__btLocPanel.parentNode) root.__btLocPanel.parentNode.removeChild(root.__btLocPanel);
    });
  });
})();
